import React from 'react';
import { RefreshCw, X } from 'lucide-react';

/**
 * UpdateAvailable Banner Component
 * Displays a banner when a new version of the app is available
 * Provides a button to reload and activate the update
 */
const UpdateAvailable = ({ onUpdate, onDismiss }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg animate-slideDown">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <RefreshCw className="w-5 h-5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-medium">New version available!</p>
              <p className="text-xs opacity-90">Click update to get the latest features</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={onUpdate}
              className="px-4 py-1.5 bg-white text-blue-600 rounded font-medium text-sm hover:bg-gray-100 transition-colors flex items-center gap-1.5"
            >
              <RefreshCw className="w-4 h-4" />
              Update Now
            </button>
            {onDismiss && (
              <button
                onClick={onDismiss}
                className="p-1.5 hover:bg-white/20 rounded transition-colors"
                title="Dismiss (will show again on next visit)"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Slide down animation */}
      <style>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default UpdateAvailable;
